import DataWrapperChart from 'components/DataWrapperChart'
import React from 'react'
import styled from 'styled-components'

import category from '../../../data/category.json'
const Wrapper = styled.div`
  position: relative;
`

const CategoryList = styled.div`
  background: #efece0;
  font-family: TamediaChart;
  display: flex;
  flex-direction: column;
  align-items: center;
  max-width: 626px;
  padding: 5px;
  flex-wrap: wrap;
  justify-content: center;
  margin: 15px auto 30px auto;
  @media (max-width: 600px) {
    margin: 15px auto 15px auto;
    position: sticky;
    top: 0;
  }
`

const CategorySelector = styled.div`
  padding: 0 6px;
  font-size: 16px;
  text-align: center;
  cursor: pointer;
  font-weight: ${props => (props.selected ? 'bold' : 'heavy')};
  color: ${props => (props.selected ? '#fff' : '#202346')};
  background-color: ${props => (props.selected ? '#202346' : undefined)};
`

const PlantList = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  margin-top: 0.25rem;
  margin-left: 0.5rem;
  margin-right: 0.5rem;
  &:after {
    content: '';
    display: block;
    width: 100%;
    margin-left: auto;
    margin-right: auto;
    margin-top: 0.5rem;
    margin-bottom: 0.5rem;
    border-top: 1px solid #DCD8C9;
  }
`
const AnimalList = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin-left: 0.25rem;
  margin-right: 0.25rem;
  justify-content: center;
  margin-bottom: 0.25rem;
  
`

function MapSelector() {
  const [selected, setSelected] = React.useState('Getreide')

  const currentCategory = category.find(c => c.category === selected)

  return (
    <Wrapper>
      {/* <div className='titleBox noBorder'> */}
        {/* <h4 className='graphicTitle'>Lorem Ipsum</h4> */}
        <div className='graphicSub'>
          Wählen Sie eine Kategorie aus, um die kantonale Landnutzung zu sehen.
        </div>
      {/* </div> */}
      <CategoryList>
        <PlantList>
          {category
            .filter(f => f.animal === 'no')
            .map((c, index) => (
              <>
                <CategorySelector
                  dangerouslySetInnerHTML={{ __html: c.category }}
                  selected={c.category === selected}
                  onClick={() => setSelected(c.category)}
                  key={index}
                >
                  {/* {c.category} */}
                </CategorySelector>
              </>
            ))}
        </PlantList>
        <AnimalList>
          {category
            .filter(f => f.animal === 'yes')
            .map((c, index) => (
              <>
                <CategorySelector
                  dangerouslySetInnerHTML={{ __html: c.category }}
                  selected={c.category === selected}
                  onClick={() => setSelected(c.category)}
                  key={index}
                >
                  {/* {c.category} */}
                </CategorySelector>
              </>
            ))}
        </AnimalList>
      </CategoryList>
      {currentCategory && <DataWrapperChart chartId={currentCategory.dw_map} />}
    </Wrapper>
  )
}

export default MapSelector
